/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для списка дополнительных телефонов в кабинете
   */
  app.UserDataPhoneListView = app.View.extend({
    phones: [],
    masks: [],
    /**
     * @param integer Количество успешных обработок телефона
     */
    successesCount: 0,
    /**
     * @param integer Количество необходимых успешных обработок телефона
     */
    reqQuantityOfSuccesses: 0,
    
    run: function () {
      var that = this;
      var view;
      
      this.collection.each(function (model) {
        view = that.phones[that.phones.length] = new app.UserPhoneView(
          {
            model: model,
            collection: that.collection,
            el: $('[data-user-phone-id = ' + model.id + ']')
          }
        );
        view.on('error-user-phone-view', that.triggerError);
      });
      
      this.initPhoneMasks();
    },
    
    triggerError: function () {
      this.trigger('error-user-data-phone-list-view');
    },
    
    render: function () {
      /**
       * @param app.UserPhoneView view
       */
      var view;
      
      /**
       * @param app.UserPhone model
       */
      var model = new app.UserPhone();
      this.collection.add(model);
      
      view = this.phones[this.phones.length] = new app.UserPhoneView({model: model, collection: this.collection});
      
      this.$el.append(view.render().el);
      var countryFlagModel = app.countryFlag.clone();
      countryFlagModel.unset('id');
      var phoneInputmask = new app.PhoneInputmaskView({el: view.$('.input_phone_additional'), model: countryFlagModel});
      phoneInputmask.render();
      new app.ChoiceCountryView({'el': view.$('.choice-country'), model: countryFlagModel});
      this.masks.push(phoneInputmask);
    },
    
    save: function () {
      var that = this;
      
      this.successesCount = 0;
      that.reqQuantityOfSuccesses = Object.keys(this.phones).length;
      if (that.reqQuantityOfSuccesses === 0) {
        this.trigger('success-user-data-phone-list-view');
      }
      this.phones.forEach(function (view, index, array) {
        if (view.removed) {
          view.off('remove-user-phone-view', that.sendSuccess, that);
          view.on('remove-user-phone-view', that.sendSuccess, that);
          view.removeModel();
          delete(array[index]);
        } else {
          view.off('success-user-phone-view', that.sendSuccess, that);
          view.on('success-user-phone-view', that.sendSuccess, that);
          view.save();
        }
      });
      this.masks.forEach(function (view) {
        view.save();
      });
    },
    
    sendSuccess: function () {
      this.successesCount++;
      
      if (this.successesCount === this.reqQuantityOfSuccesses) {
        this.successesCount = 0;
        this.trigger('success-user-data-phone-list-view');
      }
    },
    
    restore: function () {
      /**
       * @param app.UserPhoneView view
       */
      var view;
      var that = this;
      
      this.$el.html('');
      this.phones.forEach(function (view, index, array) {
        view.remove();
        if (!view.model.get('id')) {
          view.removeModel();
        }
        delete(array[index]);
      });
      this.phones = [];
      
      this.collection.each(function (model) {
        view = that.phones[that.phones.length] = new app.UserPhoneView({
          model: model
        });
        
        that.$el.append(view.render().$el);
      });
      
      this.initPhoneMasks();
    },
    
    initPhoneMasks: function () {
      var that = this;
      this.$('.choice-country').each(function () {
        var input = $(this).prev('.input_phone_additional'),
          model;
        if (input.length) {
          model = app.countryFlag.clone();
          model.unset('id');
          if (input.val()) {
            var id = input.val().replace(/\D*/, '');
            model.set('id', id);
            model.fetch();
            if (!model.get('code') && id) {
              model = app.countryFlag.clone();
              model.set({'id': id});
            }
          }
          new app.ChoiceCountryView({'el': $(this), model: model});
          var value = input.val(),
            code = model.get('code') || '+7',
            phoneInputmask = new app.PhoneInputmaskView({el: input, model: model});
          phoneInputmask.render();
          if (value && value.indexOf(code.replace('+', '')) === 0) {
            input.val(value);
          }
          that.masks.push(phoneInputmask);
        }
      });
    }
    
  });
})(jQuery);

}.call(window));